module.exports = __webpack_public_path__ + "static/media/example_image_number_revenue.1617b837.png";